module.exports = __webpack_public_path__ + "img/boddenfilms.96981afb.png";